import { Tab, TabList, TabPanel, Tabs } from '@welm/react-tabs';
import { Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import { Bar, BarChart, CartesianGrid, Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { GroupInput, Input } from '../components/Input';
import { useSystemContext } from '../Context/SystemContext';

import { translateStatus } from './LicitaEdital';
const moment = require('moment');
const yup = require('../interface/yup-br');




export const LicitaChart = () => {
    const System = useSystemContext();
    const [appSubmitForms, setAppSubmitForms] = useState([]);
    const [chartJSX, setChartJSX] = useState(null);
    const [chartVencidosJSX, setChartVencidosJSX] = useState(null);
    const [chartComissaoJSX, setChartComissaoJSX] = useState(null);
    const [periodoInicio, setPeriodoInicio] = useState(moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'));
    const [periodoFinal, setPeriodoFinal] = useState(moment().format('YYYY-MM-DD'));


    useEffect(() => {
        (async () => {
            const response = await System.apiGet(`/licitaedital`);
            if (response.status === 200) {
                setAppSubmitForms(response.data);
            }
        })();
        // eslint-disable-next-line
    }, []);

    /**
     * 
     * @argument fnClickExecutar {function} funcao que gera o grafico ao clicar no Buscar dados
     * @returns JSX
     */
    const GetPeriodo = (fnClickExecutar) => {
        return (
            <Formik
                initialValues={{
                    inicio: periodoInicio,
                    final: periodoFinal,
                }}
                onSubmit={async (values) => {
                    setPeriodoInicio(values.inicio);
                    setPeriodoFinal(values.final);
                    setChartJSX(await fnClickExecutar(new Date(values.inicio), new Date(values.final)));
                }}
                validateOnChange={true}
                validateOnBlur={true}
                enableReinitialize={true}
                validationSchema={yup.object({
                    inicio: yup.date().required('Data inicial é obrigatória'),
                    final: yup.date().required('Data final é obrigatória'),
                })
                }
            >
                {({ values, errors, setErrors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                    <Form>
                        <GroupInput>
                            <Input
                                type="date"
                                label="Data Inicial"
                                name="inicio"
                                className="w-min"
                            />
                            <Input
                                type="date"
                                label="Data Final"
                                name="final"
                                className="w-min"
                            />
                            <div className="flex flex-col">
                                <button
                                    type="submit"
                                    className="px-4 py-2 text-white rounded-md mt-7 bg-amarelo-eq"
                                >
                                    Buscar dados
                                </button>
                            </div>
                        </GroupInput>
                    </Form>
                )}
            </Formik>
        );
    }


    /**
     * arguments inicio {Date} data inicial
     * arguments final {Date} data final
     * 
     */
    const formatMonthYear = (date) => {
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const yyyy = date.getFullYear();
        return `${mm}/${yyyy}`;
    };

    const Periodo = async (inicio, final) => {
        const dataMensal = [];
        appSubmitForms.forEach((item) => {
            const data = new Date(item.cadastro);
            if (inicio <= data && final >= data) {
                const dataStr = formatMonthYear(data);
                const existingData = dataMensal.find((itemMes) => itemMes.name === dataStr);
                if (existingData) {
                    existingData.uv += 1;
                } else {
                    dataMensal.push({ name: dataStr, uv: 1 });
                }
            }
        });

        // Ordenar no formato MM/AAAA crescente
        dataMensal.sort((a, b) => {
            const [mmA, yyyyA] = a.name.split('/');
            const [mmB, yyyyB] = b.name.split('/');
            return yyyyA !== yyyyB ? Number(yyyyA) - Number(yyyyB) : Number(mmA) - Number(mmB);
        });

        const ticks = [];
        let highestUvItem = {};
        if (dataMensal.length > 0) {
            highestUvItem = dataMensal.reduce((max, item) => {
                if (!item.hasOwnProperty('uv')) {
                    console.error("Um item em dataMensal não possui a propriedade 'uv':", item);
                    return max;
                }
                return item.uv > max.uv ? item : max;
            }, dataMensal[0]);
        }
        let maxUV = highestUvItem.uv;

        maxUV += maxUV % 2 === 0 ? 2 : 3;
        for (let i = 0; i < maxUV; i += 2) ticks.push(i);

        return (
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    width={150}
                    height={200}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                    data={dataMensal}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis ticks={ticks} />
                    <Tooltip formatter={(value, name) => [value]} />
                    <Bar dataKey="uv" fill="#8884d8" />
                </BarChart>
            </ResponsiveContainer>
        );
    }

    /**
     * arguments inicio {Date} data inicial
     * arguments final {Date} data final
     * 
     */
    const porStatus = (inicio, final) => {

        let dataStatus = [];
        appSubmitForms.forEach((item) => {
            console.log('data', item.data);
            const data = new Date(item.cadastro);
            if (inicio <= data && final >= data) {
                const dataStr = translateStatus(item?.status); // nome do status, convertido de int
                const existingData = dataStatus.find((item) => item.name === dataStr);
                if (existingData) {
                    existingData.uv += 1;
                } else {
                    dataStatus.push({ name: dataStr, uv: 1 });
                }
            }
        });
        dataStatus = dataStatus.map((item) => {
            item.total = item.uv;
            item.name = `${item.name} - ${item.total}`;
            return item;
        });

        let COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#AA00FF', '#FF00AA', '#00AAFF'];
        if (COLORS.length < dataStatus.length) {
            const additionalColors = Array(dataStatus.length - COLORS.length).fill().map(() => `#${Math.floor(Math.random() * 16777215).toString(16)}`);
            COLORS.push(...additionalColors);
        }

        const RADIAN = Math.PI / 180;
        const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
            const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
            const x = cx + radius * Math.cos(-midAngle * RADIAN);
            const y = cy + radius * Math.sin(-midAngle * RADIAN);
            return (
                <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                    {`${(percent * 100).toFixed(0)}%`}
                </text>
            );
        };
        const CustomTooltip = ({ active, payload }) => {
            if (active && payload && payload.length) {
                const { name } = payload[0].payload; // Pode personalizar os dados conforme sua estrutura
                return (
                    <div className="custom-tooltip" style={{ backgroundColor: '#fff', padding: '5px', border: '1px solid #ccc' }}>
                        <p>{`${name}`}</p>
                    </div>
                );
            }
            return null;
        };


        return (
            <PieChart width={500} height={270}>
                <Pie
                    data={dataStatus}
                    cx={130}
                    cy={130}
                    labelLine={false}
                    innerRadius={0}
                    outerRadius={130}
                    fill="#8884d8"
                    paddingAngle={0}
                    dataKey="uv"
                    label={renderCustomizedLabel}
                >
                    {dataStatus.map((_, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
                <Legend layout="vertical" align="right" verticalAlign="middle" />
            </PieChart>
        );
    }


    const porConsultorVencidos = (inicio, final) => {
        const data = [];
        appSubmitForms.forEach((item) => {
            if (item.status !== 4) return;
            const dataItem = new Date(item.cadastro);
            if (inicio > dataItem || final < dataItem) return;
            const consultor = item.consultorResponsavel || 'Sem consultor';
            const existing = data.find((d) => d.name === consultor);
            if (existing) {
                existing.quantidade += 1;
            } else {
                data.push({ name: consultor, quantidade: 1 });
            }
        });
        data.sort((a, b) => b.quantidade - a.quantidade);

        return (
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    data={data}
                    margin={{ top: 5, right: 30, left: 20, bottom: 60 }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" angle={-35} textAnchor="end" interval={0} />
                    <YAxis allowDecimals={false} />
                    <Tooltip formatter={(value) => [value, 'Vencidos']} />
                    <Bar dataKey="quantidade" fill="#00C49F" />
                </BarChart>
            </ResponsiveContainer>
        );
    };

    const parseBR = (v) => parseFloat((v ?? '').replace(/[^\d,]/g, '').replace(',', '.')) || 0;

    const porComissao = (inicio, final) => {
        const data = [];
        appSubmitForms.forEach((item) => {
            if (item.status !== 4) return;
            const dataItem = new Date(item.cadastro);
            if (inicio > dataItem || final < dataItem) return;
            const consultor = item.consultorResponsavel || 'Sem consultor';
            const comissao = parseBR(item.valorVencedor) * parseBR(item.percentualComissao) / 100;
            const existing = data.find((d) => d.name === consultor);
            if (existing) {
                existing.comissao += comissao;
            } else {
                data.push({ name: consultor, comissao });
            }
        });
        data.sort((a, b) => b.comissao - a.comissao);

        const formatBRL = (v) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

        return (
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={data} margin={{ top: 5, right: 30, left: 80, bottom: 60 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" angle={-35} textAnchor="end" interval={0} />
                    <YAxis tickFormatter={(v) => formatBRL(v)} width={100} />
                    <Tooltip formatter={(value) => [formatBRL(value), 'Comissão']} />
                    <Bar dataKey="comissao" fill="#FFBB28" />
                </BarChart>
            </ResponsiveContainer>
        );
    };

    return (
        <div className='p-2 h-fit'>
            <Tabs onSelect={() => { setChartJSX(null); setChartVencidosJSX(null); setChartComissaoJSX(null); }}>
                <TabList>
                    <Tab key='periodo'>
                        Periodo
                    </Tab>
                    <Tab key='status'>
                        Status
                    </Tab>
                    <Tab key='vencidos'>
                        Vencidos
                    </Tab>
                    <Tab key='comissao'>
                        Comissão
                    </Tab>
                </TabList>
                <TabPanel>
                    <div className='h-[650px] w-full'>
                        <span className='ml-2 text-xl font-semibold'>
                            Editais no Período
                        </span>
                        <div className='h-[350px]'>
                            {GetPeriodo(Periodo)}
                            {chartJSX}
                        </div>
                    </div>
                </TabPanel>
                <TabPanel>
                    <div className='h-[650px] w-full ml-4'>
                        <span className='ml-2 text-xl font-semibold'>
                            Editais agrupados por Status
                        </span>
                        <div className='h-[450px] pt-4 pl-4'>
                            {GetPeriodo(porStatus)}
                            {chartJSX}
                        </div>
                    </div>
                </TabPanel>
                <TabPanel>
                    <div className='h-[650px] w-full'>
                        <span className='ml-2 text-xl font-semibold'>
                            Editais Vencidos por Consultor
                        </span>
                        <div className='h-[450px] pt-4'>
                            {GetPeriodo(async (inicio, final) => {
                                const jsx = porConsultorVencidos(inicio, final);
                                setChartVencidosJSX(jsx);
                                return jsx;
                            })}
                            {chartVencidosJSX}
                        </div>
                    </div>
                </TabPanel>
                <TabPanel>
                    <div className='h-[650px] w-full'>
                        <span className='ml-2 text-xl font-semibold'>
                            Comissão Total por Consultor
                        </span>
                        <div className='h-[450px] pt-4'>
                            {GetPeriodo(async (inicio, final) => {
                                const jsx = porComissao(inicio, final);
                                setChartComissaoJSX(jsx);
                                return jsx;
                            })}
                            {chartComissaoJSX}
                        </div>
                    </div>
                </TabPanel>
            </Tabs>
        </div >);
}
